import { render } from "./agent.chats.index.vue?vue&type=template&id=7c57a793"
import script from "./agent.chats.index.vue?vue&type=script&lang=js"
export * from "./agent.chats.index.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__